<template>
  <div class="part-detail-container">
    <div class="part-photo-container">
      <img class="avatar-img" :src="photoPreview" />
    </div>
    <vs-row vs-justify="center">
      <div v-if="shouldShowPhotoButton" class="part-take-photo-container">
        <label for="arquivo1">
          <span v-if="isUploading">
            <i class="fas fa-spinner fa-spin"></i> Aguarde...
          </span>
          <span v-else>
            <i class="fa fa-camera" style="margin-right: 10px"></i> Tirar foto
          </span>
        </label>
        <input
          type="file"
          ref="file0"
          name="file0"
          id="arquivo1"
          capture="camera"
          accept="image/*"
          @change="readFile(0)"
        />
      </div>
    </vs-row>
    <div>
      <h5 style="text-align: center; margin: 10px">
        {{ participantData.participant.name }}
        {{ participantData.participant.surname }}
      </h5>
      <h5 style="text-align: center; margin: 10px; color: #aaa">
        {{ participantData.participant.birthdate | calculateAge() }} anos
      </h5>
      <p></p>
    </div>
    <vs-row v-if="isCheckinOk" vs-justify="center">
      <span class="checkin-confirmed-presence"
        ><i class="fa fa-thumbs-up" style="margin-right: 5px"></i>Presença
        confirmada!</span
      >
    </vs-row>
    <vs-row
      v-else-if="isListClosed"
      vs-justify="center"
      style="flex-direction: column"
    >
      <div class="checkin-list-closed">
        <i class="fa fa-ban" style="margin-right: 5px"></i>Lista encerrada
      </div>
      <span class="checkin-list-closed-txt"
        >Não é possível realizar nenhuma ação pois a lista de participante foi
        encerrada.</span
      >
    </vs-row>
    <vs-row vs-justify="center" v-else>
      <p class="no-photo-txt" v-if="!participantData.participant.photo">
        <b>Participante sem foto.</b> O participante precisa ter foto para poder
        ter sua presença confirmada.
      </p>
      <vs-button
        @click="confirmParticipant(participantData.participant)"
        :disabled="!isCheckinReady"
      >
        <span v-if="isLoading"
          ><i class="fas fa-spinner fa-spin"></i> Aguarde...</span
        >
        <span v-if="!isLoading">Confirmar Presença</span>
      </vs-button>
    </vs-row>
  </div>
</template>

<script>
import moduleParticipant from "../../../store/participant/moduleParticipant";
import { resizeImage } from "../../../utils/image";

const defaultPreview = require("../../../assets/images/portrait/avatar.png");
export default {
  props: {
    data: {
      type: Object,
      required: false,
    },
    showCheckinModal: {
      type: Boolean,
      required: true,
    },
  },
  watch: {
    showCheckinModal(newValue) {
      console.log("Modal alterado", newValue);
      // Ajuste o estado do botão de upload e da imagem de pré-visualização toda vez que o modal é fechado
      if (newValue === false) {
        // Modal foi fechado com a foto atualizada e a presenca nao confirmada
        // Nesse caso chamar o evento photoUpdated para atualizar a lista de participantes
        if (!this.presenceWasConfirmed && this.isUploadOk) {
          this.$emit("photoUpdated");
        }

        this.preview = defaultPreview;
        this.photo = null;
        this.isUploadOk = false;
        this.isUploading = false;
        this.isLoading = false;
        this.presenceWasConfirmed = false;
      }
    },
  },
  computed: {
    participantData() {
      return this.data.selectedParticipant
        ? JSON.parse(JSON.stringify(this.data.selectedParticipant))
        : { participant: {} };
    },
    caravanist() {
      return this.data.caravanist
        ? JSON.parse(JSON.stringify(this.data.caravanist))
        : { caravanist: {} };
    },
    photoPreview() {
      const participant = this.participantData.participant;
      const hasPhoto =
        participant &&
        participant.photo &&
        participant.photo.startsWith("http");

      return hasPhoto ? participant.photo : this.preview;
    },
    isCheckinOk() {
      return this.participantData.status === true;
    },
    isListClosed() {
      return !!this.caravanist.participantListClosedAt;
    },
    shouldShowPhotoButton() {
      const noPhoto =
        !this.isCheckinOk &&
        !this.isListClosed &&
        !this.participantData.participant.photo;
      if (noPhoto) {
        if (this.isUploadOk) {
          return false;
        }
      }
      return noPhoto;
    },
    isCheckinReady() {
      return !this.shouldShowPhotoButton;
    },
  },
  filters: {
    calculateAge(date) {
      if (!date) return "";
      var ageDifMs = Date.now() - new Date(date).getTime();
      var ageDate = new Date(ageDifMs);
      return Math.abs(ageDate.getUTCFullYear() - 1970);
    },
  },
  data() {
    return {
      selectedParticipant: null,
      delectedInput: null,
      preview: defaultPreview,
      photo: null,
      participant: {},
      isLoading: false,
      isUploading: false,
      isUploadOk: false,
      presenceWasConfirmed: false,
    };
  },
  methods: {
    // Método para lidar com o fechamento do modal
    handleModalClosed() {
      // Emitindo um evento para notificar o componente pai que o modal foi fechado
      this.preview = defaultPreview;
      this.isUploadOk = false;
      this.isLoading = false;
    },
    // Método para lidar com a abertura do modal
    handleModalOpened() {
      console.log("modalOpened", this.participantData);
      const participant = this.participantData.participant;
      if (!participant.photo) {
        // Se o participante não tiver foto, ajuste o estado do botão de tirar foto e o preview da foto para o padrão
        this.isUploadOk = false;
        this.preview = defaultPreview;
      }
    },
    getParticipant() {
      if (this.data) {
        return JSON.parse(JSON.stringify(this.data.selectedParticipant));
      }
    },
    updateAvatar(base64) {
      this.isUploading = true;
      const participantData = this.getParticipant();
      this.$store
        .dispatch("participant/updatePhotoByAdmin", {
          base64,
          participantId: participantData.participant.id,
        })
        .then((resp) => {
          this.isUploading = false;
          if (resp && resp.data && resp.data.url) {
            this.participantData.participant.photo = resp.data.url;
            this.isUploadOk = true;
          } else {
            this.toastMsg(
              "Desculpe, houve um erro ao tentar fazer upload da foto.",
              false
            );
          }
        });
    },
    readFile(index) {
      let ref = null;
      switch (index) {
        case 0:
          ref = this.$refs.file0.files[0];
          break;
        case 1:
          ref = this.$refs.file1.files[0];
          break;
        case 2:
          ref = this.$refs.file2.files[0];
          break;
      }
      this.selectedInput = ref;

      const reader = new FileReader();
      reader.onloadend = () => {
        if (reader.result) {
          resizeImage(reader.result, 300, null, "dsadasd.jpg").then((res) => {
            this.preview = res;
            this.updateAvatar(res);
          });
        }
      };
      reader.readAsDataURL(this.selectedInput);
    },
    alertNotAllowed(message) {
      this.$vs.dialog({
        type: "confirm",
        color: "danger",
        title: `Lista encerrada`,
        text: message,
        acceptText: "OK",
      });
    },
    alertClosedList() {
      this.alertNotAllowed(
        `Você não pode executar essa ação pois a lista foi encerrada pelo Administrador.`
      );
    },
    toastMsg(msg, success = true) {
      this.$vs.notify({
        text: msg,
        color: success ? "success" : "danger",
        iconPack: "feather",
        icon: "icon-alert-circle",
        time: 10000,
        position: "bottom-left",
      });
    },
    confirmParticipant(item) {
      if (this.caravanist && this.caravanist.participantListClosedAt) {
        this.alertClosedList();
        return;
      }
      this.isLoading = true;
      this.$store
        .dispatch("recording/confirmParticipant", {
          recordingId: this.$route.params.id,
          participantId: item.id,
        })
        .finally(() => {
          this.isLoading = false;
          // emit
          this.$emit("presenceConfirmed", item);
          this.toastMsg(`Você confirmou a participação de "${item.name}"!`);
          // this.setWaiting(item.id, false);
        });
    },
  },
  created() {
    if (!moduleParticipant.isRegistered) {
      this.$store.registerModule("participant", moduleParticipant);
      moduleParticipant.isRegistered = true;
    }
  },
};
</script>

<style lang="scss" scoped>
.checkin-confirmed-presence {
  background: rgb(230, 255, 192);
  color: rgb(93, 154, 0);
  font-weight: bold;
  padding: 5px 10px;
  border-radius: 25px;
}
.checkin-list-closed {
  color: rgb(149, 68, 68);
  background: rgb(255, 183, 183);
  padding: 10px 20px;
  text-align: center;
  font-weight: bold;
}
.checkin-list-closed-txt {
  color: rgb(149, 68, 68);
  text-align: center;
  margin: 5px;
}
.no-photo-txt {
  color: rgb(149, 68, 68);
  text-align: center;
  margin: 16px;
}

.part-detail-container {
  display: flex;
  flex-direction: column;
}
.part-photo-container {
  align-self: center;
  width: 180px;
  height: 180px;
  margin: 10px 0;
  border-radius: 16px;
  background-color: #ddd;
}
.part-detail-container img {
  width: 100%;
  height: 100%;
  object-fit: cover;
  border-radius: 16px;
}

.part-take-photo-container {
  p {
    font-size: 15px;
    text-align: center;
  }
  input[type="file"] {
    display: none;
  }
  label {
    padding: 10px;
    width: 180px;
    border-radius: 4px;
    background-color: #333;
    color: #fff;
    font-weight: bold;
    text-transform: uppercase;
    text-align: center;
    display: flex;
    align-items: center;
    justify-content: center;
    cursor: pointer;
  }
}
</style>
